import Phaser from 'phaser';
import { CONFIG } from '../config.js';
import { getAudio } from '../systems/AudioSystem.js';

const LEVEL_TITLES = {
  basic:    { title: 'VICTORY!',        sub: 'Dark Mistress defeated!',  flavor: 'Emma escapa del bosque' },
  advanced: { title: 'VICTORY!',        sub: 'Forsaken Knight defeated!', flavor: 'Las cuevas brillan otra vez' },
  expert:   { title: 'MASTER OF VERBS', sub: 'Forest Captain defeated!',  flavor: 'Emma domina los 54 verbos' },
};

const NEXT_LEVEL = { basic: 'advanced', advanced: 'expert' };

export class VictoryScene extends Phaser.Scene {
  constructor() {
    super({ key: 'VictoryScene' });
  }

  init(data) {
    this.runStats = data.runStats || {};
    this.level = data.level || 'basic';
    this.firstClear = !!data.firstClear;
  }

  create() {
    const W = CONFIG.GAME_WIDTH;
    const H = CONFIG.GAME_HEIGHT;
    const audio = getAudio();
    audio.victory();

    if (this.level === 'expert') {
      this.renderMaster(W, H);
    } else if (this.firstClear) {
      this.renderUnlock(W, H);
    } else {
      this.renderStandard(W, H);
    }
  }

  renderStandard(W, H) {
    const meta = LEVEL_TITLES[this.level] || LEVEL_TITLES.basic;

    this.add.tileSprite(0, 0, W, H, 'tile-grass').setOrigin(0, 0).setAlpha(0.55);
    this.add.rectangle(0, 0, W, H, 0x000000, 0.55).setOrigin(0, 0);

    const title = this.add
      .text(W / 2, H * 0.18, meta.title, {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '44px',
        color: '#fde047',
        stroke: '#0f0d2c',
        strokeThickness: 8,
      })
      .setOrigin(0.5);
    this.tweens.add({ targets: title, scale: { from: 0.6, to: 1 }, duration: 500, ease: 'Back.easeOut' });
    this.tweens.add({ targets: title, angle: { from: -3, to: 3 }, duration: 1200, yoyo: true, repeat: -1, ease: 'Sine.easeInOut' });

    this.add.text(W / 2, H * 0.28, meta.sub, {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '11px',
      color: '#06b6d4',
    }).setOrigin(0.5);
    this.add.text(W / 2, H * 0.32, meta.flavor, {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '8px',
      color: '#fbbf24',
    }).setOrigin(0.5);

    this.renderStats(W, H * 0.46);

    this.makeButton(W / 2, H * 0.76, 220, 56, 'PLAY AGAIN', 0xd946ef, () => {
      this.scene.start('GameScene', { level: this.level });
    });
    this.makeButton(W / 2, H * 0.86, 220, 38, 'MENU', 0x312e81, () => {
      this.scene.start('MenuScene');
    }, '12px');

    this.add.text(W / 2, H - 14, 'by Pixie Studios  ·  2026', {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '7px',
      color: '#9ca3af',
    }).setOrigin(0.5);
  }

  renderUnlock(W, H) {
    const next = NEXT_LEVEL[this.level];
    const nextLabel = next === 'advanced' ? 'ADVANCED' : 'EXPERT';
    const meta = LEVEL_TITLES[this.level] || LEVEL_TITLES.basic;

    this.add.tileSprite(0, 0, W, H, 'tile-grass').setOrigin(0, 0).setAlpha(0.45);
    this.add.rectangle(0, 0, W, H, 0x000000, 0.7).setOrigin(0, 0);

    const title = this.add
      .text(W / 2, H * 0.16, 'VICTORY!', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '40px',
        color: '#fde047',
        stroke: '#0f0d2c',
        strokeThickness: 8,
      })
      .setOrigin(0.5);
    this.tweens.add({ targets: title, scale: { from: 0.6, to: 1 }, duration: 500, ease: 'Back.easeOut' });

    this.add.text(W / 2, H * 0.235, meta.sub, {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '10px',
      color: '#06b6d4',
    }).setOrigin(0.5);

    // Unlock banner card
    const card = this.add
      .rectangle(W / 2, H * 0.40, W - 40, 120, 0x0f0d2c, 0.95)
      .setStrokeStyle(3, 0xd946ef, 1);

    const unlockTitle = this.add
      .text(W / 2, H * 0.36, 'LEVEL UNLOCKED', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '12px',
        color: '#fbbf24',
        stroke: '#0f0d2c',
        strokeThickness: 4,
      })
      .setOrigin(0.5);

    const unlockName = this.add
      .text(W / 2, H * 0.41, nextLabel, {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '26px',
        color: '#d946ef',
        stroke: '#0f0d2c',
        strokeThickness: 5,
      })
      .setOrigin(0.5);
    this.tweens.add({
      targets: unlockName,
      scale: { from: 1, to: 1.08 },
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    const hint = next === 'advanced'
      ? '54 verbos  ·  Solo Past Simple'
      : '54 verbos  ·  Past + Participle';
    this.add.text(W / 2, H * 0.455, hint, {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '8px',
      color: '#ffffff',
    }).setOrigin(0.5);

    this.renderStats(W, H * 0.58);

    this.makeButton(W / 2, H * 0.76, 260, 56, `PLAY ${nextLabel}`, 0xd946ef, () => {
      this.scene.start('GameScene', { level: next });
    });
    this.makeButton(W / 2, H * 0.86, 220, 38, 'MENU', 0x312e81, () => {
      this.scene.start('MenuScene');
    }, '12px');

    this.add.text(W / 2, H - 14, 'by Pixie Studios  ·  2026', {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '7px',
      color: '#9ca3af',
    }).setOrigin(0.5);
  }

  renderMaster(W, H) {
    this.add.rectangle(0, 0, W, H, 0x0f0d2c, 1).setOrigin(0, 0);
    this.add.tileSprite(0, 0, W, H, 'tile-grass').setOrigin(0, 0).setAlpha(0.35);
    this.add.rectangle(0, 0, W, H, 0x000000, 0.5).setOrigin(0, 0);

    // Starfield
    for (let i = 0; i < 40; i++) {
      const sx = Phaser.Math.Between(8, W - 8);
      const sy = Phaser.Math.Between(8, H - 8);
      const star = this.add.circle(sx, sy, Phaser.Math.Between(1, 2), 0xfde047, 1);
      this.tweens.add({
        targets: star,
        alpha: { from: 0.3, to: 1 },
        scale: { from: 0.6, to: 1.4 },
        duration: Phaser.Math.Between(500, 1400),
        yoyo: true,
        repeat: -1,
        delay: Phaser.Math.Between(0, 1000),
      });
    }

    const title1 = this.add
      .text(W / 2, H * 0.18, 'MASTER', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '56px',
        color: '#fde047',
        stroke: '#0f0d2c',
        strokeThickness: 9,
      })
      .setOrigin(0.5);
    const title2 = this.add
      .text(W / 2, H * 0.27, 'OF VERBS', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '40px',
        color: '#d946ef',
        stroke: '#0f0d2c',
        strokeThickness: 8,
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: [title1, title2],
      scale: { from: 0.4, to: 1 },
      duration: 700,
      ease: 'Back.easeOut',
    });
    this.tweens.add({
      targets: title1,
      angle: { from: -2, to: 2 },
      duration: 1300,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    this.tweens.add({
      targets: title2,
      angle: { from: 2, to: -2 },
      duration: 1300,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    this.add
      .text(W / 2, H * 0.36, 'Forest Captain defeated', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '11px',
        color: '#06b6d4',
        stroke: '#0f0d2c',
        strokeThickness: 4,
      })
      .setOrigin(0.5);

    this.add
      .text(W / 2, H * 0.42, 'Emma ha dominado los 54 verbos\nen past simple Y past participle', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '9px',
        color: '#fbbf24',
        align: 'center',
        lineSpacing: 8,
        stroke: '#0f0d2c',
        strokeThickness: 3,
      })
      .setOrigin(0.5);

    this.renderStats(W, H * 0.60);

    this.makeButton(W / 2, H * 0.82, 260, 56, 'BACK TO MENU', 0xd946ef, () => {
      this.scene.start('MenuScene');
    });

    this.add
      .text(W / 2, H - 14, 'by Pixie Studios  ·  2026', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '7px',
        color: '#9ca3af',
      })
      .setOrigin(0.5);

    // Star burst particles
    this.time.delayedCall(400, () => {
      this.add.particles(W / 2, H * 0.225, 'spark', {
        speed: { min: 90, max: 200 },
        lifespan: 900,
        scale: { start: 1.4, end: 0 },
        quantity: 30,
        tint: [0xfde047, 0xd946ef, 0x06b6d4, 0xffffff],
      }).setDepth(70).explode(30);
    });
  }

  renderStats(W, y) {
    const stats = [
      `SCORE       ${this.runStats.score || 0}`,
      `KILLS       ${this.runStats.kills || 0}`,
      `BEST COMBO  x${this.runStats.bestCombo || 0}`,
      `CORRECT     ${this.runStats.correct || 0}`,
      `WRONG       ${this.runStats.wrong || 0}`,
    ];
    this.add
      .text(W / 2, y, stats.join('\n'), {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '10px',
        color: '#ffffff',
        align: 'center',
        lineSpacing: 10,
      })
      .setOrigin(0.5);
  }

  makeButton(x, y, w, h, label, fillColor, onClick, fontSize = '16px') {
    const bg = this.add.rectangle(x, y, w, h, fillColor).setStrokeStyle(3, 0xffffff, 0.95);
    const text = this.add
      .text(x, y, label, {
        fontFamily: '"Press Start 2P", monospace',
        fontSize,
        color: '#ffffff',
      })
      .setOrigin(0.5);
    bg.setInteractive({ useHandCursor: true });
    bg.on('pointerover', () => bg.setScale(1.04));
    bg.on('pointerout', () => bg.setScale(1));
    bg.on('pointerdown', () => bg.setScale(0.96));
    bg.on('pointerup', () => {
      bg.setScale(1);
      onClick();
    });
    return { bg, text };
  }
}
